import { type StackProps, PinInput, PinInputField, HStack } from "@chakra-ui/react";
import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import {
  mfaCodeFormLabelTestId,
  mfaCodeFormInputTestId,
  mfaCodeFormInput1TestId,
  mfaCodeFormInput2TestId,
  mfaCodeFormInput3TestId,
  mfaCodeFormInput4TestId,
  mfaCodeFormInput5TestId,
  mfaCodeFormInput6TestId,
} from "./const";
import { type MfaCodeFormValue } from "./type";

export interface MfaCodeFormProps extends StackProps {
  readonly label?: string;
  readonly required?: boolean;
}

export const MfaCodeForm: FC<MfaCodeFormProps> = ({ label = "二段階認証コード", required = true }) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext<MfaCodeFormValue>();

  return (
    <FormControl
      isRequired={required}
      isDirty={getValues("mfaCode").length > 0}
      isInvalid={errors.mfaCode !== undefined || getValues("mfaCode").length !== 6}
    >
      <FormLabel data-testid={mfaCodeFormLabelTestId}>{label}</FormLabel>
      <HStack justify="center">
        <PinInput
          {...register("mfaCode", {
            required: true,
            minLength: 6,
          })}
          otp
          size="md"
          type="number"
          placeholder=""
          onChange={(value) => {
            setValue("mfaCode", value, { shouldValidate: true, shouldDirty: true });
          }}
          data-testid={mfaCodeFormInputTestId}
        >
          <PinInputField data-testid={mfaCodeFormInput1TestId} />
          <PinInputField data-testid={mfaCodeFormInput2TestId} />
          <PinInputField data-testid={mfaCodeFormInput3TestId} />
          <PinInputField data-testid={mfaCodeFormInput4TestId} />
          <PinInputField data-testid={mfaCodeFormInput5TestId} />
          <PinInputField data-testid={mfaCodeFormInput6TestId} />
        </PinInput>
      </HStack>
    </FormControl>
  );
};
